<template>
    <div>
        <img width="100" :src="'data:image/png;base64,' + qrCode" v-if="qrCode" />
        <!-- <img width="100" :src="'data:image/svg+xml;base64,' + qrCode" v-if="qrCode" /> -->
        <p>Clave Secreta: {{ secretKey }}</p>

        <v-text-field v-model="otpCode" label="Código OTP"></v-text-field>
        <v-btn @click="validateOtp">Verificar</v-btn>

        <p v-if="message">{{ message }}</p>
    </div>
</template>

<script>
import axios from "../axios-auth";
export default {
    data() {
        return {
            qrCode: "",
            secretKey: "",
            otpCode: "",
            message: "",
        };
    },
    async created() {
        const response = await axios.get("/Authenticator/generate?");
        this.qrCode = response.data.qrCode;
        this.secretKey = response.data.secretKey;
    },
    methods: {
        async validateOtp() {
            const response = await axios.post("/Authenticator/validate", {
                secretKey: this.secretKey,
                code: this.otpCode,
            });

            this.message = response.data.success ? "Código válido ✅" : "Código incorrecto ❌";
        },
    },
};
</script>